import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roof-cleaning-latham-ny")({
  beforeLoad: () => {
    throw redirect({ to: "/roof-washing-latham-ny", statusCode: 301 });
  },
});
